import * as React from 'react';
import { useIntl } from 'react-intl';

import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { FadeWrapper } from './FadeWrapper';
import { messages } from './messages';
import {
  TableSubtitle,
  TableTitle,
  TableAnnotation,
  VitaminsTableWrapper,
} from './styled';
import { renderValueCell } from './utils';

type Props = {
  vitaminsAndMinerals: NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          GetCatalogProductViewQuery['productDetailByCatalogMasterId']
        >['variants'][number]['documentation']
      >['composition']
    >['vitaminsAndMinerals']
  >;
};

export const VitaminsTable = ({ vitaminsAndMinerals }: Props) => {
  const { formatMessage } = useIntl();
  const [headerRow, ...otherRows] = vitaminsAndMinerals;

  return (
    <div>
      <TableTitle>{formatMessage(messages.vitaminsAndMinerals)}</TableTitle>

      <TableSubtitle>
        {formatMessage(messages.number)} {headerRow.measureUnit}{' '}
        {formatMessage(messages.inDailyDose)} {headerRow.amount}
      </TableSubtitle>

      <FadeWrapper>
        <VitaminsTableWrapper data-testid="vitamins-table">
          <table>
            <thead>
              <tr>
                <td />
                <td>{formatMessage(messages.referenceValue)}</td>
                <td>{formatMessage(messages.onePortion)}</td>
                <td>{formatMessage(messages.referenceValueOnePercent)}</td>
                <td>{formatMessage(messages.dailyAmount)}</td>
                <td>{formatMessage(messages.referenceValuePercent)}</td>
              </tr>
            </thead>

            <tbody>
              {otherRows.map((row) => {
                const normalizedRow = {
                  ...row,
                  measureUnit: row.measureUnit ?? '',
                };
                return (
                  <tr key={row.nutritionValue}>
                    <td>{row.nutritionValue}</td>
                    <td>{renderValueCell(normalizedRow, 'referenceValue')}</td>
                    <td>
                      {renderValueCell(normalizedRow, 'onePortionAmount')}
                    </td>
                    <td>
                      {renderValueCell(
                        { ...normalizedRow, measureUnit: '%' },
                        'referenceValueOnePercent'
                      )}
                    </td>
                    <td>{renderValueCell(normalizedRow, 'amount')}</td>
                    <td>
                      {renderValueCell(
                        { ...normalizedRow, measureUnit: '%' },
                        'referenceValuePercent'
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </VitaminsTableWrapper>
      </FadeWrapper>

      <TableAnnotation>
        {formatMessage(messages.referenceValueAnnotation)}
      </TableAnnotation>
    </div>
  );
};
